<div class="wrapper">
    <div class="sidebar" data-color="azure" data-image="">
        <app-sidebar></app-sidebar>
        <div class="sidebar-background" style="background-image: url(/assets/img/sidebar-0.jpg)"></div>
    </div>

    <div class="main-panel">
        <div class="main-content">
            <!--<div class="header">
                <h1 class="h3 mb-0 text-gray-800">We are sorry!</h1>
            </div>-->

            <div class="myContainer card shadow">
                <div class="customContent">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="container-fluid form">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div>
                                            <div>
                                                <h4>{{errorMessage}}</h4>
                                            </div>

                                            <br />
                                            <div class="text-right">
                                                <a (click)="toLogin()" class="d-none d-sm-inline-block btn btn-sm btn-primary margin-right-5" style="margin-bottom: 15px;">
                                                    <i class="fas fa-sign-out-alt text-white-50"> <span class="button-text"> OK</span></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <br />
        </div>
    </div>
</div>


